module.exports = function isNumber(x) {
  return typeof x === 'number' && isFinite(x) && !isNaN(x);
};


//////////////////
// WEBPACK FOOTER
// ./~/tcomb/lib/isNumber.js
// module id = 295
// module chunks = 114276838955818